webpackJsonp([1],{

/***/ "+9z2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

  name: 'RotateLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  }
});

/***/ }),

/***/ "+CMX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPost_vue__ = __webpack_require__("znZk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb7e838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPost_vue__ = __webpack_require__("vvXR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb7e838_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+VzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YoutubePost_vue__ = __webpack_require__("EUmI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c313f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YoutubePost_vue__ = __webpack_require__("qbCv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YoutubePost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c313f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YoutubePost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+cG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/KFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("AHJT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271105fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("iXN+");
function injectStyle (ssrContext) {
  __webpack_require__("fxW9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-271105fe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_271105fe_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0N8k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0tPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain.endsWith('youtube.com') || domain === 'youtu.be';
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "24vy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"}},[_c('span',{staticStyle:{"padding-top":"6px","padding-right":"6px"}},[_vm._v("Show posts from")]),_vm._v(" "),_c('b-dropdown',[_c('button',{staticClass:"button is-primary is-outlined",attrs:{"slot":"trigger"},slot:"trigger"},[_c('span',[_vm._v(_vm._s(_vm.selectedFrom.label)+" "),_c('i',{staticClass:"fa fa-angle-down"})])]),_vm._v(" "),_vm._l((_vm.fromOptions),function(fromOption){return (fromOption.query !== _vm.selectedFrom.query)?_c('b-dropdown-item',{key:fromOption.query,on:{"click":function($event){_vm.changeFrom(fromOption)}}},[_vm._v("\n      "+_vm._s(fromOption.label))]):_vm._e()})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Bk6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThumbnailPostTitle_vue__ = __webpack_require__("9iSz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcf8cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThumbnailPostTitle_vue__ = __webpack_require__("OOQx");
function injectStyle (ssrContext) {
  __webpack_require__("FLXh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThumbnailPostTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fcf8cf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThumbnailPostTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2L46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"subreddit":_vm.subreddit}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('Tabs'),_vm._v(" "),(_vm.modifier === _vm.modifiers.CONTROVERSIAL || _vm.modifier === _vm.modifiers.TOP)?_c('div',[_c('ModifierDropdown')],1):_vm._e(),_vm._v(" "),_c('Posts',{attrs:{"modifier":_vm.modifier,"subreddit":_vm.subreddit}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3fQB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TwitchPost__ = __webpack_require__("aN8o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("pbAi");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__TwitchPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "4/iF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostFrame',_vm._b({},'PostFrame',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('PostTitle',{attrs:{"post":_vm.post}}),_vm._v(" "),(_vm.showNsfwNotice)?_c('div',[_c('NsfwPost',{attrs:{"post":_vm.post}})],1):(_vm.isLoading)?_c('div',{staticClass:"post-loader"},[_c('rotate-loader')],1):_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4D66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GfycatPost__ = __webpack_require__("FoKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("XhSa");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__GfycatPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "4fNz":
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ "4s/7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles() {
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "53qO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__("Clba");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3efe62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__("UPBJ");
function injectStyle (ssrContext) {
  __webpack_require__("mxCN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9e3efe62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e3efe62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "66rM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateLoader_vue__ = __webpack_require__("+9z2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6415a2b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateLoader_vue__ = __webpack_require__("qK/i");
function injectStyle (ssrContext) {
  __webpack_require__("qbKI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RotateLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6415a2b2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RotateLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "67Rn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain === 'streamable.com';
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "77OT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nsfwPost',
  props: ['post'],
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['openSettings', 'showNsfwPostById']), {
    showPost: function showPost() {
      var id = this.post.id;
      this.showNsfwPostById(id);
    }
  })
});

/***/ }),

/***/ "7Kpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImagePost__ = __webpack_require__("JljG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("bNy2");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__ImagePost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "7Nzo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8jLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Post__ = __webpack_require__("xCCR");



var getDetails = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
    var response, details;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.$http.get(url.slice(0, -1) + '.json');

          case 2:
            response = _context.sent;
            details = __WEBPACK_IMPORTED_MODULE_4_he___default.a.decode(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response, 'body.[0].data.children[0].data.selftext', ''));
            return _context.abrupt('return', details);

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getDetails(_x) {
    return _ref.apply(this, arguments);
  };
}();

//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'selfPost',
  props: ['post', 'color', 'textColor'],
  methods: {
    getDetails: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.memoize(getDetails)
  },
  data: function data() {
    return {
      url: this.post.url,
      details: this.details,
      isLoading: true
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.getDetails(_this.url);

            case 2:
              _this.details = _context2.sent;

              _this.isLoading = false;

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_5__components_Post__["a" /* default */],
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_2_vue_markdown___default.a
  }
});

/***/ }),

/***/ "8wj5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heading_vue__ = __webpack_require__("dfjV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2ad5b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heading_vue__ = __webpack_require__("gWIP");
function injectStyle (ssrContext) {
  __webpack_require__("Cc3E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f2ad5b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Heading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f2ad5b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Heading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9iSz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PostTitle__ = __webpack_require__("SWoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_url__ = __webpack_require__("qVre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_is_url__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thumbnailPostTitle',
  props: ['post'],
  data: function data() {
    return {
      url: this.post.url,
      thumbnail: !__WEBPACK_IMPORTED_MODULE_1_is_url___default()(this.post.thumbnail) ? 'static/reddit.jpeg' : this.post.thumbnail
    };
  },

  components: {
    PostTitle: __WEBPACK_IMPORTED_MODULE_0__components_PostTitle__["a" /* default */]
  }
});

/***/ }),

/***/ "A+JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'switches',

    props: {
        typeBold: {
            default: false
        },

        value: {
            default: false
        },

        disabled: {
            default: false
        },

        label: {
            default: ''
        },

        textEnabled: {
            default: ''
        },

        textDisabled: {
            default: ''
        },

        color: {
            default: 'default'
        },

        theme: {
            default: 'default'
        },

        emitOnMount: {
            default: true
        }
    },

    mounted: function mounted() {
        if (this.emitOnMount) {
            this.$emit('input', this.value);
        }
    },


    methods: {
        trigger: function trigger(e) {
            this.$emit('input', e.target.checked);
        }
    },

    computed: {
        classObject: function classObject() {
            var _ref;

            var color = this.color,
                value = this.value,
                theme = this.theme,
                typeBold = this.typeBold,
                disabled = this.disabled;


            return _ref = {
                'vue-switcher': true
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--unchecked', !value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--disabled', disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--bold', typeBold), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher--bold--unchecked', typeBold && !value), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher-theme--' + theme, color), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'vue-switcher-color--' + color, color), _ref;
        },
        shouldShowLabel: function shouldShowLabel() {
            return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
        }
    }
});

/***/ }),

/***/ "A82U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__ = __webpack_require__("KRQT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecbc08b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__ = __webpack_require__("AG0e");
function injectStyle (ssrContext) {
  __webpack_require__("AI/X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ecbc08b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Comment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ecbc08b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Comment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AG0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[("card " + (_vm.isRoot ? '' : 'non-root')), { 'dark-background': _vm.isDarkModeOn, 'dark-box-shadow': _vm.isDarkModeOn }],staticStyle:{"margin-bottom":"8px"}},[_c('div',{staticClass:"card-content",staticStyle:{"overflow":"auto"}},[_c('div',{staticStyle:{"text-align":"left"},on:{"click":_vm.expandCollapse}},[(!_vm.hideExpand)?_c('a',[(_vm.isExpanded)?_c('b-icon',{staticStyle:{"margin-bottom":"3px"},attrs:{"pack":"fa","icon":"caret-down","size":"is-small"}}):_c('b-icon',{staticStyle:{"margin-bottom":"3px"},attrs:{"pack":"fa","icon":"caret-right","size":"is-small"}})],1):_vm._e(),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.author))]),_vm._v("\n         ·\n        "+_vm._s(_vm.date)+"\n        "),(_vm.hasCommentSuffix)?_c('span',[_vm._v("· ")]):_vm._e(),_vm._v(" "),(!_vm.isScoreHidden)?_c('span',[_c('b-icon',{class:{ 'green-color': _vm.isUpvoted, 'red-color': !_vm.isUpvoted },staticStyle:{"margin-bottom":"3px"},attrs:{"icon":_vm.isUpvoted ? 'arrow-up' : 'arrow-down',"pack":"fa","size":"is-small"}}),_vm._v(" "),_c('span',{class:{ 'green-color': _vm.isUpvoted, 'red-color': !_vm.isUpvoted }},[_vm._v(_vm._s(_vm.score))])],1):_vm._e(),_vm._v(" "),(_vm.gildCount > 0)?_c('span',{staticStyle:{"margin-left":"2px"}},[_c('b-icon',{staticClass:"gold-color",staticStyle:{"margin-bottom":"3px"},attrs:{"pack":"fa","icon":"star","size":"is-small"}}),(_vm.gildCount > 1)?_c('span',{staticClass:"gold-color"},[_vm._v(_vm._s(_vm.gildCount))]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isMod)?_c('b-icon',{staticClass:"green-color",staticStyle:{"margin-left":"2px","margin-bottom":"3px"},attrs:{"pack":"fa","icon":"shield","size":"is-small"}}):_vm._e(),_vm._v(" "),(_vm.isSticky)?_c('b-icon',{staticClass:"fa-rotate-270 red-color",staticStyle:{"margin-left":"2px","margin-bottom":"3px"},attrs:{"pack":"fa","icon":"thumb-tack","size":"is-small"}}):_vm._e(),_vm._v(" "),(_vm.isOP)?_c('strong',{staticStyle:{"color":"#3498db","text-transform":"uppercase","margin-left":"2px"}},[_vm._v("op")]):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"7px"}},[(_vm.isExpanded)?_c('span',{staticStyle:{"text-align":"justify"},domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()]),_vm._v(" "),(_vm.isExpanded && _vm.showReplies && _vm.replies.length)?_c('div',{staticClass:"replies",style:(_vm.isRoot ? '' : 'position: relative; bottom: -10px;')},_vm._l((_vm.replies),function(reply){return _c('comment',{key:reply.id,staticStyle:{"margin-top":"15px"},attrs:{"comment":reply,"show-replies":true,"is-root":false}})})):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AHJT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typed_js__ = __webpack_require__("njrj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_typed_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_typed_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__("MvGc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var TAB_KEY = 9;
var ENTER_KEY = 13;
var DOWN_ARROW = 40;
var UP_ARROW = 38;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search',
  props: ['color', 'textColor'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isDarkModeOn'])),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$http.get('https://www.reddit.com/reddits/.json');

            case 2:
              response = _context.sent;

              _this.subreddits = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'body.data.children', []).map(function (rawSubreddit) {
                return rawSubreddit.data.display_name;
              });
              _this.$nextTick(function () {
                _this.startTyped();
              });

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  data: function data() {
    return {
      typed: null,
      subreddits: [],
      results: [],
      isResultsShown: false,
      mouseoveredResult: null
    };
  },

  methods: {
    isActive: function isActive(result) {
      return this.mouseoveredResult.name === result.name;
    },
    subredditSearchKeydown: function subredditSearchKeydown(results, event) {
      var _this2 = this;

      if (event.which === TAB_KEY) {
        event.preventDefault();
        this.$refs.subredditSearch.value = this.mouseoveredResult.name;
      }

      if (event.which === ENTER_KEY) {
        if (this.isResultsShown) {
          this.$refs.subredditSearch.value = this.mouseoveredResult.name;
          this.openSubreddit();
        } else {
          this.openSubreddit();
        }
      }

      if (event.which === DOWN_ARROW) {
        event.preventDefault();
        this.mouseoveredResult = results[__WEBPACK_IMPORTED_MODULE_6__common__["a" /* default */].mod(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(results, function (result) {
          return result.name === _this2.mouseoveredResult.name;
        }) + 1, results.length)];
      }

      if (event.which === UP_ARROW) {
        event.preventDefault();
        this.mouseoveredResult = results[__WEBPACK_IMPORTED_MODULE_6__common__["a" /* default */].mod(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(results, function (result) {
          return result.name === _this2.mouseoveredResult.name;
        }) - 1, results.length)];
      }
    },
    openSubreddit: function openSubreddit(result) {
      var subreddit = result ? result.name : this.$refs.subredditSearch.value;
      if (subreddit) {
        this.$router.push({ name: 'subreddit-page', params: { subreddit: subreddit } });
      } else {
        this.$router.push({ name: 'front-page' });
      }
      this.hideResults();
    },
    resultMouseover: function resultMouseover(result) {
      if (result.name !== '-1') {
        this.mouseoveredResult = result;
      }
    },
    prevent: function prevent(e) {
      e.preventDefault();
    },
    hideResults: function hideResults() {
      this.isResultsShown = false;
    },
    showResults: function showResults() {
      if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(this.results)) {
        this.isResultsShown = true;
      }
    },

    subredditSearchChange: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.debounce( /* eslint-disable func-names */function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event) {
        var search, response, results;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(event.which === ENTER_KEY || event.which === DOWN_ARROW || event.which === UP_ARROW)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                search = this.$refs.subredditSearch.value;

                if (search) {
                  _context2.next = 7;
                  break;
                }

                this.results = [];
                this.hideResults();
                return _context2.abrupt('return');

              case 7:
                _context2.next = 9;
                return this.$http.get('https://www.reddit.com/subreddits/search.json?q=' + search + '&limit=5');

              case 9:
                response = _context2.sent;
                results = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'body.data.children', []).map(function (_ref2) {
                  var data = _ref2.data;
                  return {
                    name: data.display_name,
                    subscribers: data.subscribers,
                    title: data.public_description || data.title
                  };
                }).filter(function (_ref3) {
                  var subscribers = _ref3.subscribers;
                  return subscribers !== null;
                });

                if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(results)) {
                  _context2.next = 14;
                  break;
                }

                this.results = [{ name: '-1' }];
                return _context2.abrupt('return');

              case 14:

                this.results = results;
                this.mouseoveredResult = results[0];
                this.showResults();

              case 17:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 200),
    stopTyped: function stopTyped() {
      if (this.typed) {
        this.typed.destroy();
      }
      this.typed = null;
    },
    startTyped: function startTyped() {
      if (!this.typed) {
        this.typed = new __WEBPACK_IMPORTED_MODULE_5_typed_js___default.a('.go-to-subreddit', {
          strings: this.subreddits,
          attr: 'placeholder',
          typeSpeed: 40,
          backSpeed: 40,
          shuffle: true,
          loop: true
        });
      }
    }
  }
});

/***/ }),

/***/ "AI/X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AO5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_RotateLoader__ = __webpack_require__("66rM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jump_js__ = __webpack_require__("q7+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_JumpToTop__ = __webpack_require__("voLU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Heading__ = __webpack_require__("8wj5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__("MvGc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var DEFAULT_SUBREDDIT_DATA = {
  color: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].DEFAULT_COLOR,
  textColor: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].getTextColor(__WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].DEFAULT_COLOR)
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page',
  props: ['subreddit', 'isCompactHeading'],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isDarkModeOn'])),
  methods: {
    jumpToTop: function jumpToTop() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_jump_js__["a" /* default */])('.jump-target');
    },
    getSubredditData: function getSubredditData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var subredditData, subredditResponse, subredditDataRaw;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                subredditData = void 0;

                if (!_this.subreddit) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return _this.$http.get('https://www.reddit.com/' + _this.subreddit + '/about.json');

              case 4:
                subredditResponse = _context.sent;
                subredditDataRaw = subredditResponse.body.data;

                subredditData = {
                  title: subredditDataRaw.title,
                  onlineUsers: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].formatNumber(subredditDataRaw.accounts_active),
                  totalUsers: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].formatNumber(subredditDataRaw.subscribers),
                  headerImg: subredditDataRaw.header_img,
                  bannerImg: subredditDataRaw.banner_img,
                  iconImg: subredditDataRaw.icon_img,
                  color: subredditDataRaw.key_color || __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].DEFAULT_COLOR
                };

                subredditData.textColor = __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].getTextColor(subredditData.color);
                _context.next = 11;
                break;

              case 10:
                subredditData = DEFAULT_SUBREDDIT_DATA;

              case 11:
                return _context.abrupt('return', subredditData);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  data: function data() {
    return {
      isLoading: true,
      subredditData: DEFAULT_SUBREDDIT_DATA
    };
  },

  watch: {
    $route: function $route(to, from) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var isNewSubredditNavigaition;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isNewSubredditNavigaition = to.params.subreddit !== from.params.subreddit;

                if (!isNewSubredditNavigaition) {
                  _context2.next = 7;
                  break;
                }

                _this2.isPageLoading = true;
                _context2.next = 5;
                return _this2.getSubredditData();

              case 5:
                _this2.subredditData = _context2.sent;

                _this2.isPageLoading = false;

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getSubredditData();

            case 2:
              _this3.subredditData = _context3.sent;

              _this3.isLoading = false;

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },

  components: {
    RotateLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_RotateLoader__["a" /* default */],
    JumpToTop: __WEBPACK_IMPORTED_MODULE_6__components_JumpToTop__["a" /* default */],
    Heading: __WEBPACK_IMPORTED_MODULE_7__components_Heading__["a" /* default */]
  }
});

/***/ }),

/***/ "APeg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CU6P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cc3E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Clba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__ = __webpack_require__("lO3e");



//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabs',
  data: function data() {
    return {
      currentModifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].HOT,
      tabs: [{
        name: 'Hot',
        icon: 'fire',
        modifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].HOT
      }, {
        name: 'New',
        icon: 'bolt',
        modifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].NEW
      }, {
        name: 'Rising',
        icon: 'line-chart',
        modifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].RISING
      }, {
        name: 'Controversial',
        icon: 'compress',
        modifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].CONTROVERSIAL
      }, {
        name: 'Top',
        icon: 'trophy',
        modifier: __WEBPACK_IMPORTED_MODULE_4__enums_modifiers__["a" /* default */].TOP
      }]
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.currentModifier = _this.$route.params.modifier;

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    this.currentModifier = this.$route.params.modifier;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isDarkModeOn'])),
  methods: {
    getRouteLink: function getRouteLink() {
      var tabModifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var currentModifier = this.currentModifier;

      if (currentModifier === tabModifier) {
        return this.$route.path;
      }

      if (!currentModifier) {
        if (this.$route.path === '/') {
          return '' + this.$route.path + tabModifier;
        }
        return this.$route.path + '/' + tabModifier;
      }

      if (!tabModifier) {
        var result = this.$route.path.replace('/' + currentModifier, tabModifier);
        if (!result) {
          return '/';
        }
        return result;
      }
      return this.$route.path.replace(currentModifier, tabModifier);
    },
    isActiveTab: function isActiveTab(tabModifier) {
      var currentModifier = this.currentModifier;
      return tabModifier === currentModifier;
    }
  }
});

/***/ }),

/***/ "CxEI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VimeoPost__ = __webpack_require__("DB7O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("Pd6Y");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__VimeoPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "D0hc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NsfwPost_vue__ = __webpack_require__("77OT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8add3e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NsfwPost_vue__ = __webpack_require__("KUHE");
function injectStyle (ssrContext) {
  __webpack_require__("0N8k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a8add3e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NsfwPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8add3e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NsfwPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DB7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VimeoPost_vue__ = __webpack_require__("RGb/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e145749a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VimeoPost_vue__ = __webpack_require__("Rn8r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VimeoPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e145749a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VimeoPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E40i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OtherPost__ = __webpack_require__("qQN0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("4s/7");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__OtherPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "EUmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getYoutubeId(url) {
  var regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  var match = url.match(regExp);
  if (match && match[2].length === 11) {
    return match[2];
  }
  return undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'youtubePost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      mediaId: getYoutubeId(this.post.url)
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "EqyH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-large the",style:({ backgroundColor: _vm.backgroundColor }),on:{"click":_vm.click}},[_c('span',{staticClass:"icon is-large"},[_c('i',{staticClass:"fa fa-chevron-up",style:({ color: _vm.color })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FF/J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThumbnailPost_vue__ = __webpack_require__("lhiZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ba2572_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThumbnailPost_vue__ = __webpack_require__("tUED");
function injectStyle (ssrContext) {
  __webpack_require__("7Nzo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c8ba2572"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThumbnailPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8ba2572_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThumbnailPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FLXh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FoKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GfycatPost_vue__ = __webpack_require__("zqey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32768800_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GfycatPost_vue__ = __webpack_require__("IF6n");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GfycatPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32768800_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GfycatPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H1qg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modifierDropdown',
  created: function created() {
    this.selectedFrom = this.getSelectedFrom();
  },
  data: function data() {
    return {
      selectedFrom: null,
      fromOptions: [{
        query: 'day',
        label: 'past 24 hours'
      }, {
        query: 'hour',
        label: 'past hour'
      }, {
        query: 'week',
        label: 'past week'
      }, {
        query: 'year',
        label: 'past year'
      }, {
        query: 'all',
        label: 'all time'
      }]
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.selectedFrom = _this.getSelectedFrom();

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  methods: {
    changeFrom: function changeFrom(fromOption) {
      this.$router.push({
        query: { show: fromOption.query }
      });
    },
    getSelectedFrom: function getSelectedFrom() {
      var show = this.$route.query.show;
      var fromOption = this.fromOptions.find(function (f) {
        return f.query === show;
      });
      if (!fromOption) {
        return this.fromOptions[0];
      }
      return fromOption;
    }
  }
});

/***/ }),

/***/ "H45V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StreamablePost__ = __webpack_require__("zDbs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("67Rn");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__StreamablePost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "HOTI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:['title post-title', { 'text-color-for-dark': _vm.isDarkModeOn }]},[_c('router-link',{attrs:{"to":_vm.permalink},nativeOn:{"click":function($event){_vm.saveScrollId(_vm.id)}}},[(_vm.isSticky)?_c('b-icon',{staticClass:"fa-rotate-270 sticky red-color",attrs:{"size":"is-medium","pack":"fa","icon":"thumb-tack"}}):_vm._e(),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")],1),_vm._v(" "),(_vm.tag)?_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.tag))]):_vm._e(),_vm._v(" "),(_vm.isNsfw)?_c('span',{staticClass:"tag nsfw red-background"},[_vm._v("nsfw")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IF6n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{staticClass:"full-width",staticStyle:{"position":"relative","padding-bottom":"57%"},attrs:{"slot":"content"},slot:"content"},[_c('iframe',{staticStyle:{"position":"absolute","top":"0","left":"0"},attrs:{"src":("https://gfycat.com/ifr/" + _vm.mediaId),"frameborder":"0","scrolling":"no","width":"100%","height":"100%","allowfullscreen":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ITIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain.startsWith('self.');
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "Iava":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({attrs:{"is-loading":_vm.isLoading}},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('a',{attrs:{"target":"_blank","href":_vm.clickUrl}},[_c('img',{staticClass:"center full-width",attrs:{"src":_vm.url}})]),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Iov5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifierDropdown_vue__ = __webpack_require__("H1qg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_361b7fd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifierDropdown_vue__ = __webpack_require__("24vy");
function injectStyle (ssrContext) {
  __webpack_require__("n2s6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-361b7fd6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModifierDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_361b7fd6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModifierDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JZSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_switches__ = __webpack_require__("lqen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__ = __webpack_require__("pHiy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'settings',
  data: function data() {
    var settings = this.$store.state.settings;
    return {
      darkModeSwitchValue: settings.darkMode === __WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__["a" /* default */].ON,
      darkModeAuto: settings.darkMode === __WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__["a" /* default */].AUTO,
      nsfwSwitchValue: settings.showNsfw
    };
  },

  computed: {
    isActive: function isActive() {
      return this.$store.state.isSettingsOpen;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['setDarkMode', 'setShowNsfw', 'closeSettings']), {
    clickDarkModeSwitch: function clickDarkModeSwitch() {
      if (this.darkModeAuto) {
        this.darkModeAuto = false;
        this.darkModeSwitchValue = !this.darkModeSwitchValue;
      }
    },
    saveDarkMode: function saveDarkMode() {
      if (this.darkModeAuto) {
        this.setDarkMode(__WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__["a" /* default */].AUTO);
      } else if (this.darkModeSwitchValue) {
        this.setDarkMode(__WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__["a" /* default */].ON);
      } else {
        this.setDarkMode(__WEBPACK_IMPORTED_MODULE_3__enums_dark_mode_states__["a" /* default */].OFF);
      }
    },
    saveShowNsfw: function saveShowNsfw() {
      this.setShowNsfw(this.nsfwSwitchValue);
    },
    close: function close(shouldSave) {
      if (shouldSave) {
        this.saveDarkMode();
        this.saveShowNsfw();
      }
      this.closeSettings();
    }
  }),
  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_1_vue_switches__["a" /* default */]
  }
});

/***/ }),

/***/ "JljG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagePost_vue__ = __webpack_require__("zU01");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c187a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagePost_vue__ = __webpack_require__("Iava");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagePost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21c187a2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagePost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KRQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__("MvGc");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'comment',
  props: ['comment', 'showReplies', 'isRoot', 'hideExpand'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isDarkModeOn']), {
    hasCommentSuffix: function hasCommentSuffix() {
      return !this.isScoreHidden || this.isOP || this.isGilded || this.isSticky;
    },
    isUpvoted: function isUpvoted() {
      return this.comment.score > 0;
    }
  }),
  methods: {
    expandCollapse: function expandCollapse() {
      if (!this.hideExpand) {
        this.isExpanded = !this.isExpanded;
      }
    }
  },
  data: function data() {
    return {
      author: this.comment.author,
      body: this.comment.body_html ? __WEBPACK_IMPORTED_MODULE_1_he___default.a.decode(this.comment.body_html) : this.comment.body,
      score: __WEBPACK_IMPORTED_MODULE_4__common__["a" /* default */].formatNumber(Math.abs(this.comment.score)),
      isScoreHidden: this.comment.score_hidden || this.comment.score === 0,
      date: __WEBPACK_IMPORTED_MODULE_4__common__["a" /* default */].formatDate(this.comment.created_utc),
      isOP: this.comment.is_submitter,
      isMod: this.comment.distinguished === 'moderator',
      gildCount: this.comment.gilded,
      isSticky: this.comment.stickied,
      replies: __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(this.comment, 'replies.data.children', []).filter(function (_ref) {
        var kind = _ref.kind;
        return kind !== 'more';
      }).map(function (_ref2) {
        var comment = _ref2.data;
        return comment;
      }),
      isExpanded: true
    };
  }
});

/***/ }),

/***/ "KUHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-text"},[_c('img',{staticStyle:{"width":"170px"},attrs:{"src":"static/waitasec.jpg"}}),_c('br'),_vm._v(" "),_vm._m(0),_c('br'),_vm._v(" "),_c('a',{staticClass:"button red-color transparent-background red-border is-outlined red-background-hover",staticStyle:{"margin-top":"25px"},on:{"click":function($event){_vm.showPost()}}},[_vm._v("Show me anyway!")]),_c('br'),_vm._v("\n  or"),_c('br'),_vm._v("\n  Turn on all NSFW posts in the "),_c('a',{on:{"click":function($event){_vm.openSettings()}}},[_vm._v("Settings")]),_vm._v(".\n")])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"25px"}},[_vm._v("This post is marked as "),_c('span',{staticClass:"red-color"},[_vm._v("Not Safe For Work")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KnAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({attrs:{"is-loading":_vm.isLoading}},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.details)?_c('p',{staticClass:"text-content"},[_c('vue-markdown',{attrs:{"source":_vm.details}})],1):_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5154f313_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("bppv");
function injectStyle (ssrContext) {
  __webpack_require__("+cG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5154f313_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MvGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postComponents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__("ViqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ImagePost__ = __webpack_require__("7Kpx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_OtherPost__ = __webpack_require__("E40i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_VideoPost__ = __webpack_require__("ZlU+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_YoutubePost__ = __webpack_require__("RZMr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_SelfPost__ = __webpack_require__("bfLJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_TwitchPost__ = __webpack_require__("3fQB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_StreamablePost__ = __webpack_require__("H45V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_GfycatPost__ = __webpack_require__("4D66");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_VimeoPost__ = __webpack_require__("CxEI");














var postComponentsArray = [__WEBPACK_IMPORTED_MODULE_4__components_ImagePost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__components_VideoPost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__components_YoutubePost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__components_SelfPost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__components_TwitchPost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__components_StreamablePost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__components_GfycatPost__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__components_VimeoPost__["a" /* default */]];
postComponentsArray.push(__WEBPACK_IMPORTED_MODULE_5__components_OtherPost__["a" /* default */]);

var postComponents = postComponentsArray.reduce(function (state, c) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, c.component.name, c.component));
}, {});

function format(n) {
  return n > 1000 ? '0.0a' : '0a';
}

function getRGBComponents(color) {
  var r = color.substring(1, 3);
  var g = color.substring(3, 5);
  var b = color.substring(5, 7);

  return {
    R: parseInt(r, 16),
    G: parseInt(g, 16),
    B: parseInt(b, 16)
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  DEFAULT_COLOR: '#c0392b',
  formatNumber: function formatNumber(n) {
    return __WEBPACK_IMPORTED_MODULE_2_numeral___default()(n).format(format(n)).toUpperCase();
  },
  getTextColor: function getTextColor(bgColor) {
    if (!bgColor) {
      return '#000000';
    }
    var nThreshold = 105;
    var components = getRGBComponents(bgColor);
    var bgDelta = components.R * 0.299 + components.G * 0.587 + components.B * 0.114;

    return 255 - bgDelta < nThreshold ? '#000000' : '#ffffff';
  },
  mod: function mod(n, m) {
    return (n % m + m) % m;
  },
  formatDate: function formatDate(date) {
    return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(parseInt(date + '000', 10)).fromNow();
  },
  handles: function handles(post) {
    var _postComponentsArray$ = postComponentsArray.find(function (postComponent) {
      return postComponent.handles(post);
    }),
        component = _postComponentsArray$.component;

    return component.name;
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tippy__ = __webpack_require__("8e0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tippy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tippy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy__ = __webpack_require__("MMSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_lib_buefy_min_css__ = __webpack_require__("gAWI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_buefy_lib_buefy_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_buefy_lib_buefy_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cool_checkboxes_for_bulma_io_dist_css_bulma_radio_checkbox_min_css__ = __webpack_require__("APeg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_cool_checkboxes_for_bulma_io_dist_css_bulma_radio_checkbox_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_cool_checkboxes_for_bulma_io_dist_css_bulma_radio_checkbox_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_scroll_restoration_polyfill__ = __webpack_require__("7y8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__("olkN");














history.scrollRestoration = 'manual';

__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale('en', {
  relativeTime: {
    future: '%s',
    past: '%s',
    s: 'now',
    ss: '%ds',
    m: '1m',
    mm: '%dm',
    h: '1h',
    hh: '%dh',
    d: '1d',
    dd: '%dd',
    M: '1mo',
    MM: '%dmo',
    y: '1y',
    yy: '%dy'
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_buefy___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_tippy___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-100520893-2',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  autoTracking: {
    exception: true
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_11__App__["a" /* default */] }
});

/***/ }),

/***/ "NrhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_markdown__ = __webpack_require__("Xoog");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_RotateLoader__ = __webpack_require__("66rM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__("MvGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_PostTitle__ = __webpack_require__("SWoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ThumbnailPostTitle__ = __webpack_require__("2Bk6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Comment__ = __webpack_require__("A82U");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











function isCommentValid(comment) {
  if (!comment.body_html) {
    return false;
  }
  var body = __WEBPACK_IMPORTED_MODULE_7_he___default.a.decode(comment.body_html);
  return !__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.includes(body, '<div class="md"><p>[removed]</p>');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postFrame',
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['isDarkModeOn']), {
    isUpvoted: function isUpvoted() {
      return this.post.score > 0;
    }
  }),
  data: function data() {
    return {
      areCommentsLoading: false,
      comments: [],
      subreddit: this.post.subreddit_name_prefixed,
      date: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].formatDate(this.post.created_utc),
      url: this.post.url,
      domain: this.post.domain,
      score: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].formatNumber(Math.abs(this.post.score)),
      permalink: this.post.permalink,
      id: this.post.id,
      commentCount: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].formatNumber(this.post.num_comments)
    };
  },

  methods: {
    closeTooltip: function closeTooltip() {
      this.$tippy.hidePopper(this.$refs.tippy);
    },
    loadTopComments: function loadTopComments(permalink) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, comments;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_4_lodash___default.a.isEmpty(_this.comments)) {
                  _context.next = 8;
                  break;
                }

                _this.areCommentsLoading = true;
                _context.next = 4;
                return _this.$http.get('https://www.reddit.com' + permalink + '.json');

              case 4:
                response = _context.sent;
                comments = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.get(response, 'body[1].data.children', []);

                _this.comments = comments.map(function (_ref) {
                  var comment = _ref.data;
                  return comment;
                }).filter(isCommentValid).slice(0, 3);
                _this.areCommentsLoading = false;

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  components: {
    VueMarkdown: __WEBPACK_IMPORTED_MODULE_5_vue_markdown___default.a,
    RotateLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_RotateLoader__["a" /* default */],
    PostTitle: __WEBPACK_IMPORTED_MODULE_9__components_PostTitle__["a" /* default */],
    ThumbnailPostTitle: __WEBPACK_IMPORTED_MODULE_10__components_ThumbnailPostTitle__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_11__components_Comment__["a" /* default */]
  },
  props: ['post', 'color', 'textColor']
});

/***/ }),

/***/ "OBeq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['modal', { 'is-active': _vm.isActive }]},[_c('div',{staticClass:"modal-background"}),_vm._v(" "),_c('div',{staticClass:"modal-card"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v("Settings")]),_vm._v(" "),_c('button',{staticClass:"delete",attrs:{"aria-label":"close"},on:{"click":function($event){_vm.close(false)}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v("Dark mode")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('span',[_c('switches',{staticStyle:{"padding-left":"5px"},attrs:{"theme":"bulma","color":"green","disabled":_vm.darkModeAuto},model:{value:(_vm.darkModeSwitchValue),callback:function ($$v) {_vm.darkModeSwitchValue=$$v},expression:"darkModeSwitchValue"}}),_vm._v(" "),_c('div',{class:{ 'in-front': _vm.darkModeAuto },staticStyle:{"position":"absolute","top":"0","bottom":"0","width":"45px"},on:{"click":function($event){_vm.clickDarkModeSwitch()}}})],1),_vm._v(" "),_c('div',{staticClass:"b-checkbox is-success is-inline",staticStyle:{"bottom":"2px","left":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.darkModeAuto),expression:"darkModeAuto"}],staticClass:"styled",attrs:{"id":"checkbox","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.darkModeAuto)?_vm._i(_vm.darkModeAuto,null)>-1:(_vm.darkModeAuto)},on:{"change":function($event){var $$a=_vm.darkModeAuto,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.darkModeAuto=$$a.concat([$$v]))}else{$$i>-1&&(_vm.darkModeAuto=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.darkModeAuto=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":"checkbox"}},[_vm._v("\n              Auto\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"field",staticStyle:{"margin-top":"25px"}},[_c('label',{staticClass:"label"},[_vm._v("Show NSFW content")]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('switches',{staticStyle:{"padding-left":"5px"},attrs:{"theme":"bulma","color":"green"},model:{value:(_vm.nsfwSwitchValue),callback:function ($$v) {_vm.nsfwSwitchValue=$$v},expression:"nsfwSwitchValue"}})],1)])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.close(true)}}},[_vm._v("Save")]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":function($event){_vm.close(false)}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OI0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('iframe',{staticClass:"center full-width",attrs:{"src":("https://clips.twitch.tv/embed?clip=" + _vm.mediaId + "&autoplay=false&tt_medium=clips_embed"),"width":"640","height":"360","frameborder":"0","scrolling":"no","allowfullscreen":"true"}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OOQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"media"},[_c('figure',{staticClass:"media-left hide-on-mobile"},[_c('p',{staticClass:"image width-128"},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.thumbnail}})])])]),_vm._v(" "),_c('div',{staticClass:"media-content"},[_c('PostTitle',_vm._b({},'PostTitle',_vm.$props,false)),_vm._v(" "),_c('p',{staticClass:"image width-128 hide-on-desktop center",staticStyle:{"margin-top":"10px"}},[_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.thumbnail}})])]),_vm._v(" "),_c('br')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pd6Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain.endsWith('vimeo.com');
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "QGOF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'text-align': _vm.isPostsLoading ? 'center' : 'left' })},[(_vm.isPostsLoading)?_c('div',{class:['post-loader full-screen-height', { 'black-background': _vm.isDarkModeOn }]},[_c('rotate-loader')],1):_c('div',{class:{ 'black-background': _vm.isDarkModeOn }},[(!_vm.posts.length)?_c('div',{staticClass:"no-posts-message"},[_c('h2',{staticClass:"title is-2"},[_vm._v("\n        No posts "),_c('b-icon',{attrs:{"pack":"fa","icon":"frown-o","size":"is-large"}})],1)]):_vm._e(),_vm._v(" "),_vm._l((_vm.posts),function(postPack){return _c('div',{key:postPack.post.id,class:("post-" + (postPack.post.id))},[_c(postPack.component,_vm._b({tag:"component"},'component',postPack,false))],1)}),_vm._v(" "),(_vm.lastPostId)?_c('infinite-loading',{staticClass:"infinite-loader",on:{"infinite":_vm.infiniteHandler}},[_c('span',{attrs:{"slot":"spinner"},slot:"spinner"},[_c('rotate-loader')],1)]):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QmxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classObject},[(_vm.shouldShowLabel)?_c('span',{staticClass:"vue-switcher__label"},[(_vm.label)?_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_vm._v(" "),(!_vm.label && _vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textEnabled)}}):_vm._e(),_vm._v(" "),(!_vm.label && !_vm.value)?_c('span',{domProps:{"textContent":_vm._s(_vm.textDisabled)}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.value},on:{"change":_vm.trigger}}),_vm._v(" "),_c('div')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RGb/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getVimeoId(url) {
  var regExp = /^.*vimeo\.com\/(.*)\??/;
  var match = url.match(regExp);
  if (match && match[1]) {
    return match[1];
  }
  return undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vimeoPost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      mediaId: getVimeoId(this.post.url)
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "RWjT":
/***/ (function(module, exports) {

module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),

/***/ "RZMr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YoutubePost__ = __webpack_require__("+VzJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("0tPy");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__YoutubePost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "Rn8r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('iframe',{attrs:{"src":("https://player.vimeo.com/video/" + _vm.mediaId + "?color=dcd5cc"),"width":"640","height":"360","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SWoU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostTitle_vue__ = __webpack_require__("pdT4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4ef8c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostTitle_vue__ = __webpack_require__("HOTI");
function injectStyle (ssrContext) {
  __webpack_require__("q+PX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f4ef8c0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UG6O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getStreamableId(url) {
  var regExp = /^.*streamable\.com\/(.*)/;
  var match = url.match(regExp);
  if (match && match[1]) {
    return match[1];
  }
  return undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'streamablePost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      mediaId: getStreamableId(this.post.url)
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "UPBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs is-centered"},[_c('ul',{class:{ 'dark-borders': _vm.isDarkModeOn }},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.name,class:{ 'is-active': _vm.isActiveTab(tab.modifier) }},[_c('router-link',{class:['tab-item', { 'dark-borders': _vm.isDarkModeOn }],attrs:{"to":_vm.getRouteLink(tab.modifier)}},[_c('i',{class:("fa fa-" + (tab.icon))}),_vm._v(" "),_c('span',{class:{ 'hide-on-mobile': !_vm.isActiveTab(tab.modifier) }},[_vm._v(" "+_vm._s(tab.name))])])],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticStyle:{"position":"absolute","left":"50%","top":"50%","-webkit-transform":"translate(-50%, -50%)","transform":"translate(-50%, -50%)"}},[_c('rotate-loader')],1):_c('div',{class:{ 'black-background': _vm.isDarkModeOn }},[_c('Heading',{attrs:{"is-compact":_vm.isCompactHeading,"color":_vm.subredditData.color,"banner-img":_vm.subredditData.bannerImg,"header-img":_vm.subredditData.headerImg,"text-color":_vm.subredditData.textColor,"subreddit":_vm.subreddit,"title":_vm.subredditData.title,"online-users":_vm.subredditData.onlineUsers,"total-users":_vm.subredditData.totalUsers}}),_vm._v(" "),_c('JumpToTop',{attrs:{"click":_vm.jumpToTop,"background-color":_vm.subredditData.color,"color":_vm.subredditData.textColor}}),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "V7RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_RotateLoader__ = __webpack_require__("66rM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PostFrame__ = __webpack_require__("XhgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PostTitle__ = __webpack_require__("SWoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_NsfwPost__ = __webpack_require__("D0hc");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'post',
  props: ['post', 'color', 'textColor', 'isLoading'],
  components: {
    PostFrame: __WEBPACK_IMPORTED_MODULE_1__components_PostFrame__["a" /* default */],
    PostTitle: __WEBPACK_IMPORTED_MODULE_2__components_PostTitle__["a" /* default */],
    RotateLoader: __WEBPACK_IMPORTED_MODULE_0_vue_spinner_src_RotateLoader__["a" /* default */],
    NsfwPost: __WEBPACK_IMPORTED_MODULE_3__components_NsfwPost__["a" /* default */]
  },
  computed: {
    showNsfwNotice: function showNsfwNotice() {
      var isNsfw = this.post.over_18;
      var settings = this.$store.state.settings;
      return isNsfw && !settings.showNsfw;
    }
  }
});

/***/ }),

/***/ "XVkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostDetails_vue__ = __webpack_require__("qecL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cd589d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostDetails_vue__ = __webpack_require__("qrCU");
function injectStyle (ssrContext) {
  __webpack_require__("fOq0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15cd589d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cd589d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Xb9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.thumbnail)?_c('ThumbnailPost',_vm._b({},'ThumbnailPost',_vm.$props,false)):_c('Post',_vm._b({},'Post',_vm.$props,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XhSa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain === 'gfycat.com';
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "XhgK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostFrame_vue__ = __webpack_require__("NrhV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a71074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostFrame_vue__ = __webpack_require__("w87I");
function injectStyle (ssrContext) {
  __webpack_require__("g86r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27a71074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a71074_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Subreddit__ = __webpack_require__("sq19");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PostDetails__ = __webpack_require__("XVkd");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'front-page',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subreddit__["a" /* default */]
  }, {
    path: '/:modifier',
    name: 'front-page-with-modifier',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subreddit__["a" /* default */]
  }, {
    path: '/r/:subreddit',
    name: 'subreddit-page',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subreddit__["a" /* default */]
  }, {
    path: '/r/:subreddit/:modifier',
    name: 'subreddit-page-with-modifier',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Subreddit__["a" /* default */]
  }, {
    path: '/r/:subreddit/comments/:postId/:postTitle',
    name: 'post',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PostDetails__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZlU+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VideoPost__ = __webpack_require__("+CMX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("pHqU");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__VideoPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "aN8o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwitchPost_vue__ = __webpack_require__("rfE/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7878ef96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwitchPost_vue__ = __webpack_require__("OI0Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TwitchPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7878ef96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TwitchPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ahUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'jumpToTop',
  props: ['click', 'backgroundColor', 'color']
});

/***/ }),

/***/ "bNy2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var url = _ref.url,
      domain = _ref.domain;

  return !url.endsWith('.gifv') && (url.includes('imgur.com/a/') || url.endsWith('.png') || url.endsWith('.jpg') || url.endsWith('.gif') || domain.endsWith('imgur.com'));
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "bfLJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SelfPost__ = __webpack_require__("paRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handles__ = __webpack_require__("ITIP");



/* harmony default export */ __webpack_exports__["a"] = ({
  component: __WEBPACK_IMPORTED_MODULE_0__SelfPost__["a" /* default */],
  handles: __WEBPACK_IMPORTED_MODULE_1__handles__["a" /* default */]
});

/***/ }),

/***/ "biLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__ = __webpack_require__("px1A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735ad283_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__ = __webpack_require__("QGOF");
function injectStyle (ssrContext) {
  __webpack_require__("dC1Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-735ad283"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735ad283_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bppv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dC1Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dfjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Search__ = __webpack_require__("/KFX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings__ = __webpack_require__("niH5");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'heading',
  props: ['color', 'bannerImg', 'headerImg', 'textColor', 'subreddit', 'title', 'onlineUsers', 'totalUsers', 'isCompact'],
  data: function data() {
    return {
      spinSettings: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapMutations */])(['resetPosts', 'openSettings']), {
    goToFrontPage: function goToFrontPage() {
      this.resetPosts();
      this.$router.push('/');
    }
  }),
  components: {
    Search: __WEBPACK_IMPORTED_MODULE_2__components_Search__["a" /* default */],
    Settings: __WEBPACK_IMPORTED_MODULE_3__components_Settings__["a" /* default */]
  }
});

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fOq0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fxW9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g86r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gAWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gWIP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Settings',{ref:"settings"}),_vm._v(" "),_c('div',{directives:[{name:"tippy",rawName:"v-tippy",value:({ position: 'left' }),expression:"{ position: 'left' }"}],staticClass:"settings-button",attrs:{"title":"Settings"},on:{"mouseover":function($event){_vm.spinSettings = true;},"mouseleave":function($event){_vm.spinSettings = false;},"click":function($event){_vm.openSettings()}}},[_c('b-icon',{class:{ 'fa-spin': _vm.spinSettings },style:({ color: _vm.textColor }),attrs:{"pack":"fa","icon":"cog"}})],1),_vm._v(" "),(_vm.isCompact)?_c('div',{staticClass:"jump-target",style:({
    'background-image': ("-webkit-linear-gradient(left, " + _vm.color + ", rgba(0,0,0,0))" + (_vm.bannerImg ? (", url(" + _vm.bannerImg + ")") : '')),
    'background-size': 'cover',
    'background-position': 'center center',
    'background-repeat': 'no-repeat',
    width: '100%',
    height: '50px',
    display: 'flex',
    'flex-direction': 'row',
    'justify-content': 'flex-start'
  })},[(_vm.subreddit)?_c('div',{staticClass:"compact-go-to-frontpage-button",staticStyle:{"align-self":"center","margin-left":"5px"}},[_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({ position: 'right' }),expression:"{ position: 'right' }"}],staticClass:"button",style:({ color: _vm.textColor, 'border-color': _vm.textColor }),attrs:{"title":"Go to Front Page"},on:{"click":function($event){_vm.goToFrontPage()}}},[_vm._v("\n        Re "),_c('i',{staticClass:"fa fa-reddit-alien",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),(_vm.subreddit)?_c('div',{style:({ color: _vm.textColor, display: 'flex', 'align-items': 'center', 'margin-left': '10px' })},[_c('router-link',{style:({ color: _vm.textColor, 'white-space': 'nowrap' }),attrs:{"to":_vm.subreddit}},[_c('strong',[_vm._v(_vm._s(_vm.subreddit))])])],1):_vm._e(),_vm._v(" "),(_vm.headerImg)?_c('div',{staticStyle:{"margin-top":"auto","margin-bottom":"auto","margin-left":"5px"}},[_c('img',{staticStyle:{"max-height":"30px","max-width":"30px"},attrs:{"src":_vm.headerImg}})]):_vm._e()]):_c('section',{staticClass:"hero is-primary is-bold jump-target"},[_c('div',{staticClass:"hero-body heading-body",style:({
      'background-image': ("-webkit-linear-gradient(left, " + _vm.color + ", rgba(0,0,0,0))" + (_vm.bannerImg ? (", url(" + _vm.bannerImg + ")") : '')),
      'background-size': 'cover',
      'background-position': 'center center',
      'background-repeat': 'no-repeat'
    })},[(_vm.subreddit)?_c('div',{staticClass:"go-to-frontpage-button"},[_c('router-link',{directives:[{name:"tippy",rawName:"v-tippy",value:({ position: 'right' }),expression:"{ position: 'right' }"}],staticClass:"button",style:({ color: _vm.textColor, 'border-color': _vm.textColor }),attrs:{"to":"/","title":"Go to Front Page"}},[_vm._v("\n          Re "),_c('i',{staticClass:"fa fa-reddit-alien",attrs:{"aria-hidden":"true"}})])],1):_vm._e(),_vm._v(" "),(_vm.headerImg)?_c('div',{staticClass:"header-img"},[(_vm.subreddit)?_c('router-link',{attrs:{"to":_vm.subreddit}},[_c('img',{attrs:{"src":_vm.headerImg}})]):_c('img',{attrs:{"src":_vm.headerImg}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.subreddit)?_c('h1',{staticClass:"title",style:({ color: _vm.textColor })},[_c('router-link',{staticStyle:{"white-space":"nowrap"},attrs:{"to":_vm.subreddit}},[_vm._v(_vm._s(_vm.subreddit))])],1):_c('h1',{staticClass:"title",style:({ color: _vm.textColor })},[_vm._v("\n          Rereddit\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[(_vm.title)?_c('span',[_c('router-link',{style:({ color: _vm.textColor }),attrs:{"to":_vm.subreddit}},[_vm._v(_vm._s(_vm.title))])],1):_c('span',{style:({ color: _vm.textColor })},[_vm._v("An alternative "),_c('i',{staticClass:"fa fa-reddit-alien",attrs:{"aria-hidden":"true"}}),_vm._v(" client")])]),_vm._v(" "),_c('Search',{attrs:{"color":_vm.color,"text-color":_vm.textColor}})],1),_vm._v(" "),(_vm.onlineUsers && _vm.totalUsers)?_c('div',{staticClass:"field is-grouped is-grouped-multiline badges"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.onlineUsers))]),_vm._v(" "),_c('span',{staticClass:"tag online-badge green-background"},[_vm._v("online")])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('div',{staticClass:"tags has-addons"},[_c('span',{staticClass:"tag"},[_vm._v(_vm._s(_vm.totalUsers))]),_vm._v(" "),_c('span',{staticClass:"tag",style:({ 'background-color': _vm.color, color: _vm.textColor })},[_vm._v("total")])])])]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gk+V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_modifiers__ = __webpack_require__("lO3e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Page__ = __webpack_require__("pMNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ModifierDropdown__ = __webpack_require__("Iov5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Tabs__ = __webpack_require__("53qO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Posts__ = __webpack_require__("biLz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subreddit',
  created: function created() {
    this.setTitle();
  },

  watch: {
    $route: function $route() {
      this.setTitle();
    }
  },
  computed: {
    subreddit: function subreddit() {
      return this.$route.params.subreddit ? '/r/' + this.$route.params.subreddit : '';
    },
    modifier: function modifier() {
      return this.$route.params.modifier;
    }
  },
  methods: {
    setTitle: function setTitle() {
      if (this.subreddit) {
        document.title = this.subreddit + ' - Rereddit';
      } else {
        document.title = 'Rereddit - alternative Reddit client';
      }
    }
  },
  data: function data() {
    return {
      modifiers: __WEBPACK_IMPORTED_MODULE_0__enums_modifiers__["a" /* default */]
    };
  },

  components: {
    Page: __WEBPACK_IMPORTED_MODULE_1__components_Page__["a" /* default */],
    Tabs: __WEBPACK_IMPORTED_MODULE_3__components_Tabs__["a" /* default */],
    ModifierDropdown: __WEBPACK_IMPORTED_MODULE_2__components_ModifierDropdown__["a" /* default */],
    Posts: __WEBPACK_IMPORTED_MODULE_4__components_Posts__["a" /* default */]
  }
});

/***/ }),

/***/ "iXN+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field has-addons",staticStyle:{"justify-content":"center"}},[_c('div',{staticClass:"control"},[_c('a',{class:['button is-static go-to-button', { 'black-border': _vm.isDarkModeOn }],style:({ 'background-color': _vm.color, color: _vm.textColor })},[_vm._v("\n      Go to /r/\n    ")])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{ref:"subredditSearch",class:['input go-to-subreddit', {
        'black-background': _vm.isDarkModeOn,
        'white-text': _vm.isDarkModeOn,
        'black-border': _vm.isDarkModeOn
      }],attrs:{"type":"text"},on:{"keyup":_vm.subredditSearchChange,"keydown":function($event){_vm.subredditSearchKeydown(_vm.results, $event)},"focus":function($event){_vm.stopTyped();_vm.showResults();},"click":function($event){_vm.showResults();},"blur":function($event){_vm.startTyped();_vm.hideResults();}}}),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isResultsShown),expression:"isResultsShown"}],staticClass:"options-list",on:{"mousedown":_vm.prevent}},[(_vm.results.length === 1 && _vm.results[0].name === '-1')?_c('li',[_vm._v("Nothing found.")]):_vm._l((_vm.results),function(result){return _c('li',{directives:[{name:"tippy",rawName:"v-tippy",value:({
          position: 'bottom-start',
          delay: [200, 0],
          size: 'small'
        }),expression:"{\n          position: 'bottom-start',\n          delay: [200, 0],\n          size: 'small'\n        }"}],key:result.name,staticClass:"results-list-item",style:({
          'background-color': _vm.isActive(result, _vm.results[0]) ? _vm.color : (_vm.isDarkModeOn ? 'black': 'white'),
          color: _vm.isActive(result, _vm.results[0]) ? _vm.textColor: (_vm.isDarkModeOn ? 'white': '#363636'),
        }),attrs:{"title":result.title},on:{"click":function($event){_vm.openSubreddit(result)},"mouseover":function($event){_vm.resultMouseover(result)}}},[_vm._v("\n        "+_vm._s(result.name)+"\n      ")])})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "l7dV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{staticClass:"full-width",attrs:{"slot":"content"},slot:"content"},[_c('iframe',{staticStyle:{"max-width":"100%","display":"flex","justify-content":"center"},attrs:{"src":("https://streamable.com/s/" + _vm.mediaId),"frameborder":"0","width":"640","height":"360","allowfullscreen":""}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  HOT: undefined,
  NEW: 'new',
  RISING: 'rising',
  CONTROVERSIAL: 'controversial',
  TOP: 'top'
});

/***/ }),

/***/ "lhiZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PostFrame__ = __webpack_require__("XhgK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ThumbnailPostTitle__ = __webpack_require__("2Bk6");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thumbnailPost',
  props: ['post', 'color', 'textColor'],
  components: {
    PostFrame: __WEBPACK_IMPORTED_MODULE_0__components_PostFrame__["a" /* default */],
    ThumbnailPostTitle: __WEBPACK_IMPORTED_MODULE_1__components_ThumbnailPostTitle__["a" /* default */]
  }
});

/***/ }),

/***/ "lqen":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_switches_vue__ = __webpack_require__("A+JM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8e4870fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_switches_vue__ = __webpack_require__("QmxO");
function injectStyle (ssrContext) {
  __webpack_require__("wCHw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_switches_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_8e4870fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_switches_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mxCN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n2s6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n3Qo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ThumbnailPost__ = __webpack_require__("FF/J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Post__ = __webpack_require__("xCCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_url__ = __webpack_require__("qVre");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_is_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_is_url__);
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'otherPost',
  props: ['post', 'color', 'textColor'],
  computed: {
    thumbnail: function thumbnail() {
      if (!__WEBPACK_IMPORTED_MODULE_2_is_url___default()(this.post.thumbnail)) {
        return '';
      }
      return this.post.thumbnail;
    }
  },
  components: {
    ThumbnailPost: __WEBPACK_IMPORTED_MODULE_0__components_ThumbnailPost__["a" /* default */],
    Post: __WEBPACK_IMPORTED_MODULE_1__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "niH5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("JZSy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a59da9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("OBeq");
function injectStyle (ssrContext) {
  __webpack_require__("zkIl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a59da9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a59da9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "olkN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_dark_mode_states__ = __webpack_require__("pHiy");







__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

var persistedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex_persistedstate__["a" /* default */])({
  key: 'rereddit',
  paths: ['settings']
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  plugins: [persistedState],
  getters: {
    isDarkModeOn: function isDarkModeOn(state) {
      if (state.settings.darkMode === __WEBPACK_IMPORTED_MODULE_5__enums_dark_mode_states__["a" /* default */].AUTO) {
        var currentHour = new Date().getHours();
        return currentHour <= 7 || currentHour >= 19;
      }
      return state.settings.darkMode === __WEBPACK_IMPORTED_MODULE_5__enums_dark_mode_states__["a" /* default */].ON;
    }
  },
  state: {
    settings: {
      darkMode: __WEBPACK_IMPORTED_MODULE_5__enums_dark_mode_states__["a" /* default */].AUTO,
      showNsfw: false
    },
    isSettingsOpen: false,
    posts: [],
    lastPostId: null,
    scrollId: null
  },
  mutations: {
    openSettings: function openSettings(state) {
      state.isSettingsOpen = true;
    },
    closeSettings: function closeSettings(state) {
      state.isSettingsOpen = false;
    },
    setDarkMode: function setDarkMode(state, value) {
      state.settings.darkMode = value;
    },
    setShowNsfw: function setShowNsfw(state, value) {
      state.settings.showNsfw = value;
    },
    initPosts: function initPosts(state, _ref) {
      var posts = _ref.posts,
          lastPostId = _ref.lastPostId;

      state.posts = posts;
      state.lastPostId = lastPostId;
    },
    resetPosts: function resetPosts(state) {
      state.posts = [];
      state.lastPostId = null;
      state.scrollId = null;
    },
    appendPosts: function appendPosts(state, _ref2) {
      var posts = _ref2.posts,
          lastPostId = _ref2.lastPostId;

      state.posts = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.posts), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(posts));
      state.lastPostId = lastPostId;
    },
    saveScrollId: function saveScrollId(state, id) {
      state.scrollId = id;
    },
    showNsfwPostById: function showNsfwPostById(state, id) {
      state.posts = state.posts.map(function (postObj) {
        if (postObj.post.id !== id) {
          return postObj;
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, postObj, {
          post: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, postObj.post, {
            over_18: false
          })
        });
      });
    }
  }
}));

/***/ }),

/***/ "pHiy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ON: 'on',
  OFF: 'off',
  AUTO: 'auto'
});

/***/ }),

/***/ "pHqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var url = _ref.url,
      domain = _ref.domain;

  return url.endsWith('.mp4') || url.endsWith('.gifv') || domain === 'v.redd.it';
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "pMNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("AO5d");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b80c958_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("UjRg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b80c958_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "paRR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfPost_vue__ = __webpack_require__("8jLU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17105a2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfPost_vue__ = __webpack_require__("KnAa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelfPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17105a2e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelfPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pbAi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function handles(_ref) {
  var domain = _ref.domain;

  return domain === 'clips.twitch.tv';
}

/* harmony default export */ __webpack_exports__["a"] = (handles);

/***/ }),

/***/ "pdT4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he__ = __webpack_require__("t02m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_he___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_he__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postTitle',
  props: ['post'],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['isDarkModeOn'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapMutations */])(['saveScrollId'])),
  data: function data() {
    return {
      id: this.post.id,
      url: this.post.url,
      isSticky: this.post.stickied,
      isNsfw: this.post.over_18,
      title: __WEBPACK_IMPORTED_MODULE_1_he___default.a.decode(this.post.title),
      tag: __WEBPACK_IMPORTED_MODULE_1_he___default.a.decode(this.post.link_flair_text || ''),
      permalink: this.post.permalink
    };
  }
});

/***/ }),

/***/ "px1A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_RotateLoader__ = __webpack_require__("66rM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__ = __webpack_require__("qK+J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__("MvGc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Post__ = __webpack_require__("xCCR");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'posts',
  data: function data() {
    return {
      colors: {},
      isPostsLoading: true
    };
  },

  props: ['subreddit', 'modifier'],
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['isDarkModeOn']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["d" /* mapState */])(['posts', 'lastPostId', 'scrollId']), {
    show: function show() {
      return this.$route.query.show;
    }
  }),
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!__WEBPACK_IMPORTED_MODULE_5_lodash___default.a.isEmpty(_this.posts)) {
                _context.next = 8;
                break;
              }

              _context.t0 = _this;
              _context.next = 4;
              return _this.getPosts();

            case 4:
              _context.t1 = _context.sent;

              _context.t0.initPosts.call(_context.t0, _context.t1);

              _context.next = 9;
              break;

            case 8:
              if (_this.scrollId) {
                _this.$nextTick(function () {
                  return setTimeout(function () {
                    return document.querySelector('.post-' + _this.scrollId).scrollIntoView();
                  }, 100);
                });
              }

            case 9:
              _this.isPostsLoading = false;

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    $route: function $route(to, from) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(from.name !== 'post')) {
                  _context2.next = 9;
                  break;
                }

                _this2.isPostsLoading = true;
                _this2.resetPosts();
                _context2.t0 = _this2;
                _context2.next = 6;
                return _this2.getPosts();

              case 6:
                _context2.t1 = _context2.sent;

                _context2.t0.initPosts.call(_context2.t0, _context2.t1);

                _this2.isPostsLoading = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapMutations */])(['initPosts', 'resetPosts', 'appendPosts']), {
    getColorByPost: function getColorByPost(_ref) {
      var subreddit = _ref.subreddit_name_prefixed;

      return this.colors[subreddit].color;
    },
    getTextColorByPost: function getTextColorByPost(_ref2) {
      var subreddit = _ref2.subreddit_name_prefixed;

      return this.colors[subreddit].textColor;
    },
    populateColorBySubreddit: function populateColorBySubreddit(subreddit) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, color, textColor;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.colors[subreddit]) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return _this3.$http.get('https://www.reddit.com/' + subreddit + '/about.json');

              case 3:
                response = _context3.sent;
                color = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(response, 'body.data.key_color') || __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].DEFAULT_COLOR;
                textColor = __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].getTextColor(color);

                _this3.colors[subreddit] = { color: color, textColor: textColor };

              case 7:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getPosts: function getPosts() {
      var _this4 = this;

      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          after = _ref3.after;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var modifier, show, requestUrl, response, posts, subreddits, lastPostId, postPacks;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                modifier = _this4.modifier ? '/' + _this4.modifier : '';
                show = (_this4.modifier === 'controversial' || _this4.modifier === 'top') && _this4.show ? '&sort=' + _this4.modifier + '&t=' + _this4.show : '';
                requestUrl = 'https://www.reddit.com/' + _this4.subreddit + modifier + '.json?limit=10' + show;

                if (after) {
                  requestUrl += '&after=t3_' + after;
                }
                _context4.next = 6;
                return _this4.$http.get(requestUrl);

              case 6:
                response = _context4.sent;
                posts = response.body.data.children.map(function (_ref4) {
                  var post = _ref4.data;
                  return post;
                });
                subreddits = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniq(posts.map(function (post) {
                  return post.subreddit_name_prefixed;
                }));

                // prefetch subreddits

                _context4.next = 11;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(subreddits.map(function (subreddit) {
                  return _this4.populateColorBySubreddit(subreddit);
                }));

              case 11:
                lastPostId = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.get(posts, '[' + (posts.length - 1) + '].id');
                postPacks = posts.map(function (post) {
                  return {
                    post: post,
                    color: _this4.getColorByPost(post),
                    textColor: _this4.getTextColorByPost(post),
                    component: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].handles(post)
                  };
                });
                return _context4.abrupt('return', { posts: postPacks, lastPostId: lastPostId });

              case 14:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    infiniteHandler: function infiniteHandler($state) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.lastPostId) {
                  _context5.next = 3;
                  break;
                }

                $state.loaded();
                return _context5.abrupt('return');

              case 3:
                _context5.t0 = _this5;
                _context5.next = 6;
                return _this5.getPosts({ after: _this5.lastPostId });

              case 6:
                _context5.t1 = _context5.sent;

                _context5.t0.appendPosts.call(_context5.t0, _context5.t1);

                $state.loaded();

              case 9:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  }),
  components: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_7_vue_infinite_loading___default.a,
    Post: __WEBPACK_IMPORTED_MODULE_9__components_Post__["a" /* default */],
    RotateLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_RotateLoader__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_8__common__["b" /* postComponents */])
});

/***/ }),

/***/ "q+PX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qEtq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qK/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"v-spinner"},[_c('div',{staticClass:"v-rotate v-rotate1",style:(_vm.spinnerStyle)},[_c('div',{staticClass:"v-rotate v-rotate2",style:(_vm.spinnerStyle)}),_c('div',{staticClass:"v-rotate v-rotate3",style:(_vm.spinnerStyle)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qQN0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherPost_vue__ = __webpack_require__("n3Qo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008bca67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherPost_vue__ = __webpack_require__("Xb9O");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OtherPost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_008bca67_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OtherPost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qbCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('iframe',{staticClass:"center full-width",attrs:{"width":"640","height":"360","src":("https://www.youtube.com/embed/" + _vm.mediaId + "?rel=0&showinfo=0"),"frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qbKI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qecL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Page__ = __webpack_require__("pMNZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Comment__ = __webpack_require__("A82U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_RotateLoader__ = __webpack_require__("66rM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common__ = __webpack_require__("MvGc");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'postDetails',
  data: function data() {
    return {
      isPostLoading: true,
      isCommentsLoading: true,
      postPack: null,
      comments: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var permalink, response, subredditResponse, color, textColor, post;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.scrollTo(0, 0);
              permalink = _this.$route.path;
              _context.next = 4;
              return _this.$http.get('https://www.reddit.com' + permalink + '.json');

            case 4:
              response = _context.sent;
              _context.next = 7;
              return _this.$http.get('https://www.reddit.com/' + _this.subreddit + '/about.json');

            case 7:
              subredditResponse = _context.sent;
              color = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(subredditResponse, 'body.data.key_color') || __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].DEFAULT_COLOR;
              textColor = __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].getTextColor(color);
              post = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response, 'body[0].data.children[0].data', {});

              _this.comments = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.get(response, 'body[1].data.children', []).filter(function (_ref) {
                var kind = _ref.kind;
                return kind !== 'more';
              }).map(function (_ref2) {
                var comment = _ref2.data;
                return comment;
              });

              _this.postPack = {
                post: post,
                color: color,
                textColor: textColor,
                component: __WEBPACK_IMPORTED_MODULE_8__common__["a" /* default */].handles(post)
              };

              _this.isPostLoading = false;
              _this.isCommentsLoading = false;

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['isDarkModeOn']), {
    subreddit: function subreddit() {
      return this.$route.params.subreddit ? '/r/' + this.$route.params.subreddit : '';
    }
  }),
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    Page: __WEBPACK_IMPORTED_MODULE_5__components_Page__["a" /* default */],
    RotateLoader: __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_RotateLoader__["a" /* default */],
    Comment: __WEBPACK_IMPORTED_MODULE_6__components_Comment__["a" /* default */]
  }, __WEBPACK_IMPORTED_MODULE_8__common__["b" /* postComponents */])
});

/***/ }),

/***/ "qrCU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"subreddit":_vm.subreddit,"is-compact-heading":true}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[(_vm.isPostLoading)?_c('div',{class:['post-loader full-screen-height', { 'black-background': _vm.isDarkModeOn }]},[_c('rotate-loader')],1):_c('div',{class:{ 'black-background': _vm.isDarkModeOn }},[_c(_vm.postPack.component,_vm._b({tag:"component"},'component',_vm.postPack,false)),_vm._v(" "),(_vm.isCommentsLoading)?_c('div',{staticClass:"post-loader"},[_c('rotate-loader')],1):_c('div',{staticClass:"container",staticStyle:{"max-width":"1200px","margin-bottom":"100px"}},_vm._l((_vm.comments),function(comment){return _c('Comment',{key:comment.id,attrs:{"show-replies":true,"comment":comment,"is-root":true}})}))],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rfE/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function getTwitchId(url) {
  var regExp = /^.*clips\.twitch\.tv\/(.*)\??/;
  var match = url.match(regExp);
  if (match && match[1]) {
    return match[1];
  }
  return undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'twitchPost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      mediaId: getTwitchId(this.post.url)
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "rm//":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sq19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subreddit_vue__ = __webpack_require__("gk+V");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380b53e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subreddit_vue__ = __webpack_require__("2L46");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subreddit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_380b53e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subreddit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tUED":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PostFrame',_vm._b({},'PostFrame',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('ThumbnailPostTitle',{attrs:{"post":_vm.post}}),_vm._v(" "),_vm._t("content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "voLU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JumpToTop_vue__ = __webpack_require__("ahUG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddf61108_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JumpToTop_vue__ = __webpack_require__("EqyH");
function injectStyle (ssrContext) {
  __webpack_require__("qEtq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ddf61108"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JumpToTop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ddf61108_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JumpToTop_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vvXR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Post',_vm._b({},'Post',_vm.$props,false),[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('video',{staticClass:"center full-width full-screen-height-max",attrs:{"preload":"auto","autoplay":"","muted":"","loop":"","webkit-playsinline":"","playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.url,"type":"video/mp4"}})]),_vm._v(" "),_c('br',{staticClass:"hide-on-desktop"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w87I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['card post', { 'dark-background': _vm.isDarkModeOn, 'dark-box-shadow': _vm.isDarkModeOn }]},[_c('header',{staticClass:"card-header",style:({ 'background-color': _vm.color })},[_c('p',{staticClass:"card-header-title no-wrap",style:({ 'color': _vm.textColor, overflow: 'auto' })},[_c('router-link',{attrs:{"to":("/" + _vm.subreddit)}},[_vm._v(_vm._s(_vm.subreddit))]),_vm._v("\n       ·\n      "+_vm._s(_vm.date)+"\n      · \n      "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.domain))])],1)]),_vm._v(" "),_c('div',{staticClass:"card-content",staticStyle:{"overflow-x":"auto"}},[_c('div',{staticClass:"content"},[_vm._t("content")],2)]),_vm._v(" "),_c('footer',{class:['card-footer', { 'dark-borders': _vm.isDarkModeOn }]},[_c('label',{class:['card-footer-item', { 'green-color': _vm.isUpvoted, 'red-color': !_vm.isUpvoted }]},[_c('b-icon',{staticStyle:{"margin-right":"8px"},attrs:{"pack":"fa","icon":_vm.isUpvoted ? 'arrow-up': 'arrow-down'}}),_vm._v(" "+_vm._s(_vm.score)+"\n    ")],1),_vm._v(" "),_c('a',{directives:[{name:"tippy",rawName:"v-tippy",value:({
      maxWidth: '700px',
      theme: _vm.isDarkModeOn ? 'dark' : 'light',
      arrow: true,
      interactive: true,
      size: 'small',
      sticky: true,
      delay: [300, 100],
      popperOptions: {
        modifiers: {
          flip: {
            enabled: false
          }
        }
      }
    }),expression:"{\n      maxWidth: '700px',\n      theme: isDarkModeOn ? 'dark' : 'light',\n      arrow: true,\n      interactive: true,\n      size: 'small',\n      sticky: true,\n      delay: [300, 100],\n      popperOptions: {\n        modifiers: {\n          flip: {\n            enabled: false\n          }\n        }\n      }\n    }"}],ref:"tippy",staticClass:"card-footer-item",attrs:{"data-html":("#tooltip-content-" + _vm.id)},on:{"mouseover":function($event){_vm.loadTopComments(_vm.permalink)}}},[_c('div',{staticStyle:{"display":"none"},attrs:{"id":("tooltip-content-" + _vm.id)}},[_c('strong',{class:{ 'text-color-for-dark' : _vm.isDarkModeOn }},[_c('b-icon',{staticStyle:{"margin-bottom":"4px"},attrs:{"pack":"fa","icon":"trophy","size":"is-small"}}),_vm._v(" Top Comments\n        ")],1),_vm._v(" "),(_vm.areCommentsLoading)?_c('div',[_c('rotate-loader',{staticStyle:{"margin-top":"14%","margin-bottom":"13%"}})],1):_c('div',{staticClass:"top-comments-body"},[(!_vm.comments.length)?_c('div',[_c('h4',{staticClass:"title is-4",staticStyle:{"margin-top":"25px","color":"#95a5a6"}},[_vm._v("No comments")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.comments),function(comment){return _c('Comment',{key:comment.id,attrs:{"comment":comment,"hide-expand":true}})})],2),_vm._v(" "),_c('button',{staticClass:"button is-primary hide-on-desktop",staticStyle:{"width":"55%","margin-bottom":"10px","margin-top":"20px"},attrs:{"onclick":("document.getElementById('close-tooltip-" + _vm.id + "').click()"),"id":("close-tooltip-" + _vm.id)},on:{"click":_vm.closeTooltip}},[_vm._v("\n          Close\n        ")])]),_vm._v(" "),_c('b-icon',{staticStyle:{"margin-right":"8px"},attrs:{"pack":"fa","icon":"comments-o"}}),_vm._v(" "),_c('router-link',{attrs:{"to":_vm.permalink}},[_vm._v(_vm._s(_vm.commentCount))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wCHw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xCCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__ = __webpack_require__("V7RX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21afe888_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__ = __webpack_require__("4/iF");
function injectStyle (ssrContext) {
  __webpack_require__("rm//")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21afe888"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Post_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21afe888_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Post_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zDbs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamablePost_vue__ = __webpack_require__("UG6O");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02efb34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamablePost_vue__ = __webpack_require__("l7dV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StreamablePost_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02efb34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StreamablePost_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zU01":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imagePost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      url: this.post.url,
      clickUrl: this.post.url,
      isLoading: true
    };
  },
  created: function created() {
    var _this = this;

    var domain = this.post.domain;
    var isImgurAlbum = this.url.includes('imgur.com/a/');
    if (isImgurAlbum) {
      this.url = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.get(this.post, 'media.oembed.thumbnail_url', '').replace('?fb', '');
    } else if (domain === 'imgur.com') {
      this.url = this.url.replace('imgur.com', 'i.imgur.com') + '.jpg';
    }
    var image = new Image();
    image.src = this.url;
    image.onload = function () {
      _this.isLoading = false;
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_1__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "zkIl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "znZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'videoPost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    var url = this.post.url;
    var domain = this.post.domain;

    if (domain === 'v.redd.it') {
      url = this.post.media.reddit_video.fallback_url;
    } else if (url.endsWith('.gifv')) {
      url = url.replace(/gifv$/, 'mp4');
    }

    return {
      url: url
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_0__components_Post__["a" /* default */]
  }
});

/***/ }),

/***/ "zqey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Post__ = __webpack_require__("xCCR");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function getGfycatId(url) {
  var regExp = /^.*gfycat\.com\/(.*)/;
  var match = url.match(regExp);
  if (match) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.last(url.split('/'));
  }
  return undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gfycatPost',
  props: ['post', 'color', 'textColor'],
  data: function data() {
    return {
      mediaId: getGfycatId(this.post.url)
    };
  },

  components: {
    Post: __WEBPACK_IMPORTED_MODULE_1__components_Post__["a" /* default */]
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e0f93749fa2380c0a56d.js